import { createFileRoute, redirect } from "@tanstack/react-router"
import { sdk } from "src/sdk"
import { appStore, setActiveOrganizationId } from "src/store"
import { OrganizationOnboarding } from "src/views/OrganizationOnboardingViews/OrganizationOnboarding"

export const Route = createFileRoute("/_loggedIn/organizations")({
	component: OrganizationOnboarding,
	loader: async () => {
		const organizations = await sdk.organizations.refreshStore()

		if (organizations.length === 1) {
			appStore.dispatch(setActiveOrganizationId(organizations[0]!.uuid))
			throw redirect({ from: "/organizations", to: "/" })
		}

		return organizations
	},
})
